import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { Observable, Subscription, timer } from 'rxjs';

import { UiConstant } from '~/constant/ui.constant';
import { uiHelper } from '~/helpers/ui.helper';
import { FixtureModel, LiveFixture, OddTypeModel } from '~/legacy/ts/categories/categories';
import { CoreService } from '~/legacy/ts/services/core.service';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { OddModel } from '~/legacy/ts/tournaments/tournaments';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'preFixture',
    templateUrl: './pre.fixture.html',
})
export class PreFixture implements OnInit {
    public fixtureStyles = this._UiConstant.fixtureStyles;
    public matchCopy: any;
    public selectedOddType = 1;
    @Input('match') public match: FixtureModel;
    @Input() public isScoreBox = false;
    @Input() public _bufferAmount = 10;

    public expandShowMatchId = null;

    public init: boolean;
    public oddTypes: Observable<OddTypeModel[]>;

    public liveData;

    public mergedData;

    private subscriptionsToStopOnDestroy: Subscription[] = [];

    public styles = {
        virtualScroll: {
            height: this.tournamentsService.Page_Window_Height - 255 + 'px',
        },
    };

    @ViewChild(VirtualScrollerComponent, { static: false })
    private virtualScroller: VirtualScrollerComponent;

    constructor(
        public tournamentsService: TournamentsService,
        public _UiConstant: UiConstant,
        private _uiHelper: uiHelper,
    ) {}

    public ngOnInit() {
        this._uiHelper.setTypeOfList('pre');

        if (this.init) {
            return;
        }
        this.init = true;
        this.matchCopy = this.match;
        this.tournamentsService.fixturetourId = 0;
        this.tournamentsService.fixturecatId = 0;
        this.tournamentsService.fixturesportId = 1;

        // this.tournamentsService.getSportFixture("pre.fixture.ts");
        this.changeSelectedOdds(1);

        // this.tournamentsService.terminalFixtureListByCategories;
        // this.tournamentsService.getSportFixturebyCatagory(); Tüm futbol karşılaşmalarını category e göre çağaracak

        this.expandShowMatchId = this._uiHelper.expandId;

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.expandIdListener.subscribe(x => {
                this.expandShowMatchId = x;
            }),
        );

        this.reDataBuild();

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.changeSportFixture.subscribe(x => {
                this.reDataBuild();
                if (this.virtualScroller) {
                    this.virtualScroller.scrollToPosition(0);
                }
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.changeSportFixtureSort.subscribe(() => {
                this.reDataBuild();
                if (this.virtualScroller) {
                    this.virtualScroller.scrollToPosition(0);
                    //console.warn("this.virtualScroller.scrollToPosition(0) 99");
                }
            }),
        );

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.preScrollChange.subscribe(x => {
                this.changeScroll(x);
            }),
        );

        this.styles = {
            virtualScroll: {
                height: this.isScoreBox
                    ? this.tournamentsService.Page_Window_Height + 150 + 'px'
                    : this.tournamentsService.Page_Window_Height - 255 + 'px',
            },
        };
    }

    public reDataBuild() {
        //console.log('rebuild');
        this.mergedData = [
            ...(this.tournamentsService.terminalFixtureList ? this.tournamentsService.terminalFixtureList : []),
        ];

        const sortBy = (items: any[], reverse: boolean, sortedBy: string) => {
            let shortedData;

            if (!reverse) {
                if (items != null)
                    shortedData = items.sort((a, b) => {
                        let nameA = a[sortedBy];
                        let nameB = b[sortedBy];
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                    });
            } else {
                shortedData = items.sort((a, b) => {
                    let nameA = a[sortedBy];
                    let nameB = b[sortedBy];
                    if (nameA > nameB) {
                        return -1;
                    }
                    if (nameA < nameB) {
                        return 1;
                    }
                });
            }

            return shortedData;
        };

        if (this.tournamentsService.activeSortTypeOfLive == 'standart') {
            this.mergedData = sortBy(this.mergedData, false, 'SequenceNumber');
        } else {
            this.mergedData = sortBy(this.mergedData, false, 'EventDate');
        }

        this.mergedData = this.mergedDataIndexer(this.mergedData);
    }

    changeScroll(direction) {
        const CHANGE_VALUE = 250;
        this.virtualScroller.scrollToPosition(
            this.virtualScroller.viewPortInfo.scrollStartPosition + (direction === 'up' ? CHANGE_VALUE : -CHANGE_VALUE),
        );
    }

    public mergedDataIndexer(_data) {
        return _data.map((item, i) => {
            item.IndexCount = i;
            item.IndexOdd = i % 2;
            return item;
        });
    }

    public expandNotifierHandler(e, k) {
        if (this.expandShowMatchId === e) {
            this._uiHelper.setExpandId(null);
        } else {
            this._uiHelper.setExpandId(e);
        }

        this.virtualScroller.invalidateCachedMeasurementAtIndex(k);
    }
    public changeSelectedOdds(e) {
        this.selectedOddType = e;
        // this.matchCopy.Loading = "active";
        this.oddTypes = this.tournamentsService.getOddType(e, this.matchCopy);
    }

    public clickOdd(oddId) {
        this.tournamentsService.addOdd(oddId, $('input[name="__RequestVerificationToken"]').val());
        this.tournamentsService.matchtimeScore = 'UpComing';
    }

    public checkOddId(oddId) {
        const index = this.tournamentsService.slipCurrents.findIndex(v => {
            return v.OddId1 == oddId;
        });
        if (index > -1) {
            return 'eylem';
        } else {
            return '';
        }
    }

    public getBgColorEOU(i) {
        if (i % 2 == 0) {
            return '#1C1C1C';
        } else {
            return '#404040';
        }
    }

    public getBgColorTGS(i) {
        if (i % 2 == 0) {
            return '#323232';
        } else {
            return '#525252';
        }
    }

    public expand(e) {
        if (e.isExpanded) {
            e.isExpanded = false;
        } else {
            e.isExpanded = true;
            e.Odds = this.tournamentsService.getOddType(12, e.MatchId);
        }
    }

    ngOnDestroy(): void {
        for (let subscription of this.subscriptionsToStopOnDestroy) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}
